import { isLoopbackHostname } from '@/lib/otel/otlp-cors-origin'

const OTLP_PROXY_PATH = '/api/otlp'

function isAppOtlpProxyPath(pathname: string): boolean {
  const normalized = pathname.replace(/\/+$/, '') || '/'
  return normalized === OTLP_PROXY_PATH || normalized.startsWith(`${OTLP_PROXY_PATH}/`)
}

export function resolveBrowserOtlpExporterUrl(configuredUrl: string, browserOrigin?: string): string {
  if (!browserOrigin) return configuredUrl

  try {
    const configured = new URL(configuredUrl)
    const origin = new URL(browserOrigin)

    if (isLoopbackHostname(configured.hostname) || isAppOtlpProxyPath(configured.pathname)) {
      return `${origin.origin}${OTLP_PROXY_PATH}`
    }

    return configuredUrl
  } catch {
    return configuredUrl
  }
}
